var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"blog-list-section"},[_c('mobile-gutter',[_c('b-row',[_c('b-col',{attrs:{"xl":"10","offset-xl":"1"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{key:_vm.blogs.map(function (ref) {
	var title = ref.title;

	return title;
}).join('-'),staticClass:"list"},_vm._l((_vm.blogs),function(item){return _c('div',{key:item.title,staticClass:"list-item"},[_c('item-card',{attrs:{"image":item.thumbnail,"name":item.title,"description":_vm.formattedDate(item.dateTime),"to":item.to}})],1)}),0)])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }